import { CFImage, CFVideo } from '../../type/client-index'

export const LesliePresentation: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/37537eb2-667d-4562-fa24-654baaf5c100/1750',
  width: 1500,
  height: 1000
}

export const LeslieFleures: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/aa714834-15e9-46bc-4558-de9b2b200400/1750',
  width: 1000,
  height: 1500
}

export const Leslie1: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/c10c611d-7461-433f-6678-f394aedfbc00/1750',
  width: 1000,
  height: 1500
}

export const Leslie2: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/fbc42f36-0a6b-4a67-ca8a-a3cb800a6400/1750',
  width: 1000,
  height: 1500
}

export const Leslie3: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/d063eac5-b7c1-4239-ac96-2276c4d79f00/1750',
  width: 1000,
  height: 1500
}

export const Leslie4: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/561b87da-ee1f-407d-adf8-2d00f51f6400/1750',
  width: 1000,
  height: 1500
}

export const Leslie5: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/982c6836-5214-4ea9-92b5-3862d3a21a00/1750',
  width: 1000,
  height: 1500
}

export const Leslie6: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/9da827d9-f031-425c-5c09-a0ceff18a400/1750',
  width: 1000,
  height: 1500
}

export const Leslie7: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/edf5caff-c197-4143-5162-7f51dba4aa00/1750',
  width: 1000,
  height: 1500
}

export const Leslie8: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/1058ecaa-7fb1-4885-d938-e5a2101e8000/1750',
  width: 1000,
  height: 1500
}

export const Leslie9: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/4c82f1a6-183d-46aa-d71c-216b5e07b100/1750',
  width: 1000,
  height: 1500
}

export const Leslie10: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/2c649c8a-7dbc-4bf3-9fa4-ca99c88e2b00/1750',
  width: 1000,
  height: 1500
}

export const Leslie11: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/a0fec10c-5376-4be0-b49c-31681e9e5e00/1750',
  width: 1001,
  height: 1500
}

export const Leslie12: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/eae5e9bb-a70e-43c6-9252-c5498092b800/1750',
  width: 1001,
  height: 1500
}

export const Leslie13: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/d736430b-7250-4f95-8184-1bf6a778c600/1750',
  width: 1001,
  height: 1500
}

export const Leslie14: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/ae2763a1-d786-48bb-48fb-44846d356700/1750',
  width: 1001,
  height: 1500
}

// VIDEO

export const Video1: CFVideo = {
  id: '103b6ea8886d23e9d75018e5fc746ab5',
  cover: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/df0d9bdc-8050-457d-bdf9-84b49099f700/1750'
}

export const Video2: CFVideo = {
  id: 'a4cbfac23d615bff38813b5567a2cba1',
  cover: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/3916f8cd-394b-4e4c-00d9-308582409500/1750'
}

export const Video3: CFVideo = {
  id: '3ef2aefeb8699ec767d7f3dd57841153',
  cover: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/d1124bf5-390a-4483-21bd-3265beb08a00/1750'
}
